// extracted by mini-css-extract-plugin
export default {"paymentSuccessWrapper":"successDisplay_paymentSuccessWrapper__6UOQE","enterTerminal":"successDisplay_enterTerminal__NuJdM","glowing":"successDisplay_glowing__sGQh7"};